import VueEditor from "../../../../plugins/VueEditor/VueEditor";
import CollectionApi from "../../../../services/api/collectionApi.js";
import ProductsApi from "../../../../services/api/productApi.js";
import algoliasearch from "algoliasearch/lite";
import draggable from "vuedraggable";
import _debounce from "lodash/debounce";
import uid from "uid";

const CollectionApiService = new CollectionApi(),
  ProductApiService = new ProductsApi(),
  SINGLE_FETCH_PRODUCTS_LIMIT = 1000;

export default {
  components: {
    VueEditor,
    draggable,
  },

  data() {
    return {
      hideInactiveProducts: false,
      productSearchQuery: "",
      product_arrays: [],
      removedProducts: [],
      loaded: false,
      change_occured: false,
      request_started: false,
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      searchIndexBrands: null,
      searchIndexTag: null,
      image_size_limit: 10000000,
      file: null,
      image: null,
      uploading: false,
      collection: {
        product_search_criteria: [],
        description: "",
        title: "",
        collection_type: "MANUAL",
        active: true,
        include_all_conditions: false,
        tags: [],
      },
      originalImageUrl: null,
      categories: [],
      brands: [],
      conditions: [],
      selected_move_value: null,
      selected_products: [],
      products: [],
      productsRequestId: undefined,
    };
  },

  computed: {
    isEdit() {
      return this.$route.params.id;
    },
  },

  beforeRouteLeave(from, to, next) {
    const _self = this;

    if (_self.change_occured) {
      _self
        .$swal({
          title: "Are you sure?",
          text: "Your changes wont be saved",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          confirmButtonText: "Confirm",
        })
        .then(function (confirm) {
          if (confirm.value) {
            next();
          }
        });
    } else {
      next();
    }
  },

  beforeMount() {
    this.searchIndexTag = this.algoliaClient.initIndex(this.$env.getOrigin() + "_tags");
    this.searchIndexBrands = this.algoliaClient.initIndex(this.$env.getOrigin() + "_brands");
    this.searchIndexProducts = this.algoliaClient.initIndex(this.$env.getOrigin() + "_products");

    this.getConditions();
    this.getConditionsData();
  },

  methods: {
    addProductToCollection,
    removeProductFromHidden,
    hideProductFromCollection,
    unhideProductFromCollection,
    triggerImageUpload,
    removeImage,
    onCollectionImageInputChange,
    generateImage,
    unselectProducts,
    selectProducts,
    moveProducts,
    back,
    getBrands,
    getProductCategories,
    attachImageToCollection,
    removeCollectionHeaderImage,
    getCollection,
    parseConditionData,
    submit,
    save,
    removeCollectionConfirm,
    removeCollection,
    removeProduct,
    splitIntoArrays,
    prepareGetObjects,
    getProducts,
    getRemovedProducts,
    getConditions,
    getConditionsData,
    getProductIds: _debounce(getProductIds, 800),
    updateConditionKey,
    updateConditionOperator,
    updateConditionValue,
    addNewCondition,
    removeCondition,
    setDefaultConditionValue,
    searchTags,
    collectionSavedCallback,
    removeProductsFromCollection,
  },

  watch: {
    collection: {
      handler() {
        if (this.loaded) {
          this.change_occured = true;
        }
      },
      deep: true,
    },

    "collection.collection_type": function () {
      if (this.$route.params.id) {
        this.removeProductsFromCollection();
      }
    },
  },
};

function addProductToCollection(product) {
  const result = this.products.filter((item) => item.id === product.id);

  if (!result.length) {
    this.products.push(product);
    this.productSearchQuery = "";
  }
}
function removeProductFromHidden(index) {
  this.removedProducts.splice(index, 1);
}

function hideProductFromCollection(index) {
  const product = { ...this.products[index] };
  this.products.splice(index, 1);

  this.removedProducts.push(product);
}

function unhideProductFromCollection(index) {
  const product = { ...this.removedProducts[index] };
  this.removedProducts.splice(index, 1);

  this.products.push(product);
}

function back() {
  let routeQuery = {
    page: this.$route.query.page,
  };

  if (this.$route.query.collection_query) routeQuery.collection_query = this.$route.query.collection_query;

  this.$router.push({
    name: "dashboardCollections",
    query: routeQuery,
  });
}

function removeProductsFromCollection() {
  this.products = [];
  this.collection.product_ids = [];
}

function getConditions() {
  CollectionApiService.getConditions()
    .then(({ data }) => {
      this.condition_keys = data.condition_keys;
      this.condition_operators = data.condition_operators;
    })
    .catch((error) => {
      this.$utils.handleError(this, error);
    });
}

async function getProductCategories() {
  this.categories = await this.$utils.getProductCategories();
}

async function getConditionsData() {
  await this.getProductCategories();
  await this.getBrands();

  if (this.isEdit) {
    this.getCollection();
  }
}

function triggerImageUpload() {
  this.$refs.collection_image_input.click();
}

function onCollectionImageInputChange(e) {
  if (!e.target.files.length) return;

  this.file = e.target.files[0];

  if (this.file.size > this.$utils.getByteSizeFromMegabyteSize(this.$utils.constants.IMAGE_UPLOAD_SIZE_LIMIT_MB)) {
    this.removeImage();
    e.target.value = "";
    return this.$swal({ title: this.$utils.constants.IMAGE_UPLOAD_SIZE_LIMIT_ERROR_MESSAGE });
  } else {
    this.uploading = true;

    setTimeout(() => {
      this.generateImage(this.file, this);
    }, 2500);
  }
}

function generateImage(file, _self) {
  let reader = new FileReader(),
    image = new Image();

  reader.readAsDataURL(file);
  reader.onload = (e) => {
    image.src = e.target.result;
  };

  image.onload = (e) => {
    if (
      image.naturalWidth > _self.$utils.imageSize("collectionImage") ||
      image.naturalHeight > _self.$utils.imageSize("collectionImage")
    ) {
      _self.$swal(
        "Attention",
        "Image size cannot be greater than " +
          _self.$utils.imageSize("collectionImage") +
          " x " +
          _self.$utils.imageSize("collectionImage")
      );

      return;
    } else {
      this.collection.image_url = e.target.src;
    }

    _self.uploading = false;
  };
}

function removeImage() {
  this.collection.image_url = "";
  this.file = null;
}

function addNewCondition() {
  this.conditions.push({
    condition_keys: [...this.condition_keys],
    condition_operators: [...this.condition_operators],
    tags: [],
    labels: {
      key: null,
      operator: null,
      value: null,
    },
    product_search_criteria: {
      key: null,
      operator: null,
      value: null,
    },
  });

  this.updateConditionKey(this.condition_keys[0], this.conditions.length - 1);
  this.updateConditionOperator(this.condition_operators[0], this.conditions.length - 1);

  if (this.isEdit) this.getProductIds();
}

function removeCondition(index) {
  this.$validator.reset();
  this.conditions.splice(index, 1);

  if (this.isEdit) this.getProductIds();
}

function updateConditionKey(obj, index) {
  this.conditions[index].labels.key = obj.name;
  this.conditions[index].product_search_criteria.key = obj.value;

  // reset condition value on each key update
  this.conditions[index].product_search_criteria.value = null;

  // check which operators are available for given key
  this.conditions[index].condition_keys.forEach((condition_key) => {
    if (condition_key.value === this.conditions[index].product_search_criteria.key) {
      updateAvailableItems(this.conditions[index].condition_operators, condition_key.available_operators);
    }
  });

  this.updateConditionOperator(this.condition_operators[0], index);
  this.setDefaultConditionValue(this.conditions[index].product_search_criteria.key, index);
}

function updateConditionOperator(obj, index) {
  this.conditions[index].labels.operator = obj.name;
  this.conditions[index].product_search_criteria.operator = obj.value;

  if (this.isEdit) {
    switch (this.conditions[index].product_search_criteria.key) {
      case "wholesale_price":
      case "compare_at_price":
        if (this.conditions[index].product_search_criteria.value) {
          this.getProductIds();
        }
    }
  }
}

function updateConditionValue(obj, index) {
  switch (this.conditions[index].product_search_criteria.key) {
    case "brand":
      this.conditions[index].labels.value = obj.name;
      this.conditions[index].product_search_criteria.value = obj.id;

      break;

    case "category":
      this.conditions[index].labels.value = obj.info.text;
      this.conditions[index].product_search_criteria.value = obj.entity_id;

      break;

    case "tag":
      this.conditions[index].tag_query = obj.name;
      this.conditions[index].product_search_criteria.value = obj.name;
      this.conditions[index].tags = [];

      break;
  }

  if (this.isEdit) {
    this.getProductIds();
  }
}

function setDefaultConditionValue(type, index) {
  switch (type) {
    case "brand":
      this.conditions[index].labels.value = this.brands[0].name;
      this.conditions[index].product_search_criteria.value = this.brands[0].id;

      break;

    case "category":
      this.conditions[index].labels.value = this.categories[0].view_components[0].info.text;
      this.conditions[index].product_search_criteria.value = this.categories[0].view_components[0].entity_id;

      break;

    case "wholesale_price":
    case "compare_at_price":
      this.conditions[index].labels.value = 0;
      this.conditions[index].product_search_criteria.value = 0;

      break;
  }

  if (this.isEdit) {
    this.getProductIds();
  }
}

function updateAvailableItems(items, available_items) {
  //reset available operators
  for (let i = 0; i < items.length; i++) {
    items[i].available = false;
  }

  for (let i = 0; i < items.length; i++) {
    for (let j = 0; j < available_items.length; j++) {
      if (items[i].value === available_items[j]) {
        items[i].available = true;
      }
    }
  }

  return items;
}

async function getBrands() {
  try {
    const { data } = await this.$utils.getAllBrands(true);
    this.brands = data.brands_dropdown;
  } catch (error) {
    this.$swal("Attention", this.$utils.formatErrorMessage("brands"));
  }
}

function submit() {
  if (this.request_started) {
    return;
  }

  this.request_started = true;

  this.$validator.validate().then((valid) => {
    if (!valid) {
      this.request_started = false;

      return;
    }

    this.save();
  });
}

function save() {
  this.$loader.$emit("trigger", true);
  const method = this.$route.params.id ? CollectionApiService.save : CollectionApiService.create;

  const request = {
    ...this.collection,
  };

  if (this.file) request.image_url = null;

  if (this.isEdit) {
    request.product_ids = [];
    request.removed_product_ids = [];

    this.products.forEach((product, index) => {
      request.product_ids.push({
        id: product.id,
        ordinal: index + 1,
      });
    });

    this.removedProducts.forEach((item, index) => {
      request.removed_product_ids.push({
        id: item.id,
        ordinal: this.products.length + index + 1,
      });
    });

    request.id = this.$route.params.id;
  }

  if (this.collection.collection_type === "AUTOMATED") {
    let criteria = getSearchCriteria(this.conditions);
    request.product_search_criteria = [];

    criteria.forEach((item) => {
      if (item.value) {
        request.product_search_criteria.push(item);
      }
    });
  }

  method(request)
    .then((response) => {
      const id = response.data.id ? response.data.id : this.$route.params.id;

      if (this.file) {
        this.attachImageToCollection(id);
      } else if (this.originalImageUrl && !this.collection.image_url) {
        this.removeCollectionHeaderImage(id);
      } else {
        this.collectionSavedCallback();
      }
    })
    .catch((error) => {
      this.request_started = false;
      this.$utils.handleError(this, error);
    })
    .finally(() => {
      this.$loader.$emit("trigger", false);
    });
}

function attachImageToCollection(id) {
  let formData = new FormData();

  formData.append("image", this.file, "image.jpg");

  CollectionApiService.attachImageToCollection(formData, id)
    .then(() => {
      this.collectionSavedCallback();
    })
    .catch((error) => {
      this.$utils.handleError(this, error);
    });
}

function removeCollectionHeaderImage(id) {
  CollectionApiService.removeCollectionHeaderImage(id)
    .then(() => {
      this.collectionSavedCallback();
    })
    .catch((error) => {
      this.$utils.handleError(this, error);
    });
}

function collectionSavedCallback() {
  this.$loader.$emit("trigger", false);
  this.$swal("Success", "Collection successfully saved");
  this.change_occured = false;
  this.loaded = false;
  this.back();
}

function getSearchCriteria(data) {
  let product_search_criteria = [];

  for (let i = 0; i < data.length; i++) {
    product_search_criteria.push(data[i].product_search_criteria);
  }

  return product_search_criteria;
}

function getCollection() {
  CollectionApiService.getCollection(this.$route.params.id)
    .then(async ({ data }) => {
      this.collection = data;
      this.originalImageUrl = data.image_url;

      if (this.collection.include_all_conditions === null) {
        this.collection.include_all_conditions = false;
      }

      if (data.search_criteria_list) {
        for (let i = 0; i < data.search_criteria_list.length; i++) {
          this.conditions.push(this.parseConditionData(data.search_criteria_list[i]));
        }
      }

      if (data.product_ids.length) {
        this.product_ids = data.product_ids;
        await this.prepareGetObjects(data.product_ids);
      }

      if (data.removed_product_ids.length) {
        this.removedProducts = data.removed_product_ids;
        await this.getRemovedProducts(data.removed_product_ids);
      }

      this.loaded = true;
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$logger.notify(new Error(error));
      }
    });
}

function parseConditionData(data) {
  let condition = {
    condition_keys: [...this.condition_keys],
    condition_operators: [...this.condition_operators],
    tags: [],
    labels: {
      key: null,
      operator: null,
      value: null,
    },
    product_search_criteria: {
      key: data.key,
      operator: data.operator,
      value: data.value,
    },
  };

  for (let i = 0; i < condition.condition_keys.length; i++) {
    if (condition.condition_keys[i].value === data.key) {
      condition.labels.key = condition.condition_keys[i].name;

      break;
    }
  }

  for (let i = 0; i < condition.condition_operators.length; i++) {
    if (condition.condition_operators[i].value === data.operator) {
      condition.labels.operator = condition.condition_operators[i].name;

      break;
    }
  }

  if (data.key === "category") {
    for (let i = 0; i < this.categories.length; i++) {
      for (let j = 0; j < this.categories[i].view_components.length; j++) {
        if (this.categories[i].view_components[j].entity_id === data.value) {
          condition.labels.value = this.categories[i].view_components[j].info.text;

          break;
        }
      }
    }
  } else if (data.key === "brand") {
    for (let i = 0; i < this.brands.length; i++) {
      if (this.brands[i].id === data.value) {
        condition.labels.value = this.brands[i].name;

        break;
      }
    }
  } else if (data.key === "tag") {
    condition.tag_query = data.value;
  }

  condition.condition_keys.forEach((key) => {
    if (key.value === data.key) {
      updateAvailableItems(condition.condition_operators, key.available_operators);
    }
  });

  return condition;
}

function getProductIds() {
  this.$validator.validate().then((valid) => {
    if (valid) {
      this.$loader.$emit("trigger", true);
      this.products = [];

      let data = parseConditionsToString(getSearchCriteria(this.conditions));

      if (data) {
        let request = {
          include_all_conditions: this.collection.include_all_conditions,
          search_criteria: data.toString(),
        };

        this.productsRequestId = uid();

        ProductApiService.getProductsBySearchCriteria(request)
          .then((response) => {
            if (response.removed_product_ids) {
              this.getRemovedProducts(response.removed_product_ids);
            }

            if (response.data.product_ids.length) {
              this.prepareGetObjects(response.data.product_ids, this.productsRequestId);
            } else {
              this.products = [];
              this.collection.product_ids = [];
            }
          })
          .catch((error) => {
            this.$swal("Attention", error.response.data.error_message);
          })
          .finally(() => {
            this.$loader.$emit("trigger", false);
          });
      } else {
        this.$loader.$emit("trigger", false);
      }
    }
  });
}

function prepareGetObjects(ids, id) {
  /*
        algolias .getObjects method doesn't support pagination params,
        so we are splitting array of product ids into small arrays
    */

  let array = [];

  if (ids.length > SINGLE_FETCH_PRODUCTS_LIMIT) {
    array = this.splitIntoArrays(ids, SINGLE_FETCH_PRODUCTS_LIMIT);
  } else {
    array = [ids];
  }

  this.getProducts(0, array);
}

function getProducts(i, array) {
  const _self = this;

  if (i < array.length) {
    _self.searchIndexProducts.getObjects(array[i]).then((response, err) => {
      if (err) {
        _self.$swal("Attention", err);

        return;
      }

      let products = [];

      response.results.forEach(function (product) {
        if (product !== null && product.id && product.name) {
          products.push({
            active: product.active,
            id: product.id,
            name: product.name,
            image: product.image ? product.image : null,
            selected: false,
            visible: product.visible,
            brand: product.brand ? product.brand.company_name : "n/a",
          });
        }
      });

      if (!_self.products.length) {
        _self.products = products;
      } else {
        _self.products = _self.products.concat(products);
      }

      i++;
      _self.getProducts(i, array);
    });
  }
}

function getRemovedProducts(ids) {
  this.searchIndexProducts.getObjects(ids).then((response, err) => {
    if (err) {
      this.$swal("Attention", err);

      return;
    }

    let products = [];

    response.results.forEach(function (product) {
      if (product !== null && product.id && product.name) {
        products.push({
          id: product.id,
          name: product.name,
          image: product.image ? product.image : null,
          selected: false,
          visible: product.visible,
          brand: product.brand ? product.brand.company_name : "n/a",
        });
      }
    });

    this.removedProducts = products;
  });
}

function parseConditionsToString(data) {
  let array = [];

  for (let i = 0; i < data.length; i++) {
    if (data[i].key === "category") {
      array.push("category=" + data[i].value);
    } else if (data[i].key === "brand") {
      array.push("brand=" + data[i].value);
    } else if (data[i].key === "compare_at_price") {
      array.push("compare_at_price" + data[i].operator + data[i].value);
    } else if (data[i].key === "wholesale_price") {
      array.push("wholesale_price" + data[i].operator + data[i].value);
    } else if (data[i].key === "tag") {
      array.push("tag=" + data[i].value);
    }
  }

  return array.toString();
}

function removeCollectionConfirm() {
  const _self = this;

  this.$swal({
    title: "Attention",
    text: "Are you sure you want to delete this collection?",
    showCancelButton: true,
    cancelButtonText: "Cancel",
    confirmButtonText: "Confirm",
  }).then(function (confirm) {
    if (confirm.value) {
      _self.removeCollection();
    }
  });
}

function removeCollection() {
  CollectionApiService.deleteCollection(this.$route.params.id)
    .then(() => {
      this.$swal("Success", "You have successfully removed collection!");
      this.$router.push("/dashboard/collections");
    })
    .catch((error) => {
      this.$utils.handleError(this, error);
    });
}

function removeProduct(index) {
  this.products.splice(index, 1);
}

function splitIntoArrays(arr, n) {
  let res = [];

  while (arr.length) {
    res.push(arr.splice(0, n));
  }

  return res;
}

function unselectProducts() {
  this.products.forEach((product) => {
    product.selected = false;
  });

  this.selected_move_value = null;
  this.selected_products = [];
}

function selectProducts(product) {
  let index = this.selected_products.indexOf(product);

  if (index === -1) {
    this.selected_products.push(product);
  } else {
    this.selected_products.splice(index, 1);
  }

  this.selected_move_value = null;
}

function moveProducts(val) {
  const _self = this;

  _self.selected_move_value = val.name;

  // remove selected products from products main array
  _self.products = _self.products.filter((item) => item.selected === false);

  if (val.name.toLowerCase() === "top") {
    _self.selected_products.reverse();
    _self.selected_products.forEach((item) => {
      _self.products.unshift(item);
    });
  } else {
    _self.products = _self.products.concat(_self.selected_products);
  }
}

function searchTags(index) {
  this.conditions[index].product_search_criteria.value = null;

  this.searchIndexTag.clearCache();
  this.searchIndexTag
    .search({
      query: this.conditions[index].tag_query,
      hitsPerPage: 2000,
    })
    .then((response, err) => {
      if (err) {
        this.$swal("Attention", this.$utils.formatErrorMessage("tags"));

        return;
      }

      this.conditions[index].tags = response.hits;
    });
}
